function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.1814 3.25922C9.04083 3.84516 8.64883 5.50687 8.78698 6.5625C7.26 4.83844 7.32249 2.85609 7.32249 0C2.42521 1.77328 3.5641 6.885 3.41716 8.4375C2.18552 7.46953 1.95266 5.15625 1.95266 5.15625C0.652189 5.79891 0 7.51453 0 8.90625C0 12.2719 2.84112 15 6.34615 15C9.85118 15 12.6923 12.2719 12.6923 8.90625C12.6923 6.90609 11.1629 5.9836 11.1814 3.25922Z",
  fill: "currentcolor"
});

var SvgTeho = function SvgTeho(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTeho, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/teho.7f74a803.svg";
export { ForwardRef as ReactComponent };